// extracted by mini-css-extract-plugin
module.exports = {"tabDown":"tabs_tabDown__xouS5","activeTab":"tabs_activeTab__1scvY","dNone":"tabs_dNone__3MNoz","tabs":"tabs_tabs__1ppVm"};